<template>
  <section>
    <v-card dark class="gradient__withAnimation">
      <particles>
        <!-- toolbar -->
        <home-toolbar></home-toolbar>
        <!-- toolbar -->

        <!-- banner -->
        <v-container grid-list-lg>
          <v-layout row wrap justify-center align-center>
            <v-flex md5 xs12 order-md1 order-sm2 order-xs2>
              <v-layout align-center justify-center row fill-height>
                <v-card
                  data-aos="fade-right"
                  data-aos-delay="200"
                  flat
                  class="pt-4 transparent"
                  >
                  <v-card-text>
                    <h1 class="display-1 mb-3">
                      <strong v-html="item.bannerTitle"></strong>
                    </h1>
                    <p class="font_-weight--bold mb-3" v-html="item.bannerDescription"></p>
                  </v-card-text>
                </v-card>
              </v-layout>
            </v-flex>

            <v-flex md6 offset-md1 xs12 order-md2 order-sm1 order-xs1>
              <v-card
                data-aos="fade-left"
                data-aos-delay="200"
                flat
                class="transparent mb-4"
                >
                <img
                  @contextmenu.prevent="preventRightClick"
                  :src="item.thumbnail"
                  alt=""
                  width="100%"
                >
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <!-- banner -->
      </particles>
    </v-card>

    <!-- content -->
    <v-container grid-list-lg>
      <v-layout row wrap justify-center align-center>
        <v-flex xl8 lg9 md12 xs12>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="py-5">
                <p v-html="content.overview"></p>
              </div>
              <div class="py-3">
                <h2 class="primary--text">{{ __('The PEbAAL pedagogy works this way:') }}</h2>
              </div>

              <div class="py-3">
                <template v-for="(item, i) in content.items">
                  <v-card-text
                    data-aos="fade-up"
                    :data-aos-delay="item.dataDelay"
                    :key="i"
                    class="px-4 py-3"
                    >
                    <v-layout row justify-start align-start>
                      <v-avatar
                        color="blue lighten-5"
                        size="50"
                        class="mr-4"
                        >
                        <img :src="item.count">
                      </v-avatar>
                      <p v-html="item.text"></p>
                    </v-layout>
                  </v-card-text>
                </template>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- content -->

    <footer-component></footer-component>
  </section>
</template>

<script>
import store from '@/store'
import banner from '@/modules/CDA/Strategy/assets/images/learning-strategy.svg'
import countOne from '@/modules/CDA/Strategy/assets/icons/1.png'
import countTwo from '@/modules/CDA/Strategy/assets/icons/2.png'
import countThree from '@/modules/CDA/Strategy/assets/icons/3.png'
import countFour from '@/modules/CDA/Strategy/assets/icons/4.png'
import countFive from '@/modules/CDA/Strategy/assets/icons/5.png'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  store,
  name: 'LearningStrategy',

  components: {
    AOS
  },

  data () {
    return {
      bannerSubtitle: true,
      item: {
        thumbnail: banner,
        bannerTitle: 'Learning Strategy',
        bannerDescription: 'At Cyber Defence Academy, our learning strategy emphasises performance-based, experiential, adaptive, and agile learning, which we term <em><strong>PEbAAL</strong></em>.',
      },
      content: {
        overview: 'The <em><strong>PEbAAL</strong></em> pedagogy will be applied across all our learning platforms that integrates content, pedagogical strategies, and real world lifelong learning. For example, when a participant learns either through face-to-face learning, e-learning, or hybrid learning, the learning experience will go beyond the classroom and into the workplace. We require our participants to be exposed to real world setting from the time they leave school and continuing their lifelong learning journey at their workplace. The emphasis is on real world experience that would boost corporate or organisational performance.',
        items: [
          {
            count: countOne,
            text: 'Using design thinking methodology, we start by identifying the problem to be solved or the value to be created. We carry out a user needs analysis to figure out what needs to be done in order to solve a problem or create value.',
            dataDelay: 200,
          },
          {
            count: countTwo,
            text: 'If a problem can be solved through learning and development, we then develop a learning roadmap geared towards solving the problem. If the problem cannot be solved through learning problems (for example, personality clashes), we do not proceed with the PEbAAL approach, but attempt to solve the problem through face-to-face human interactions.',
            dataDelay: 300,
          },
          {
            count: countThree,
            text: '<p>The learning roadmap will comprise the following elements</p><ol type="a"><li>Problem identification</li><li>User needs analysis</li><li>Learning strategy design which will focus on adaptive and agile learning</li><li>Tailored learning contents directed at problem solving</li><li>Integrated learning and development platform backed by a learning and training management system</li><li>Evaluation framework using the updated Kirkpatrick evaluation methodology</li><li>Review and refinement to ensure that the organisational KPIs (Key Performance Indicator) are met</li></ol>',
            dataDelay: 400,
          },
          {
            count: countFour,
            text: 'Academic institutions are encouraged to create a student e-Portfolio that would capture the students’ learning experiences which they can share with their future employers or partners. Organisations that require support to create these cloud based e-Portfolio can contact us.',
            dataDelay: 500,
          },
          {
            count: countFive,
            text: 'Organisations and enterprises are also encouraged to create their own Skills Portfolio for their employees and this can be connected with our knowledge and skills bank that is constantly updated as part of our adaptive and agile learning.',
            dataDelay: 600,
          }
        ]
      }
    }
  },

  mounted () {
    this.preventRightClick()

    AOS.init({
      once: true,
    })
  },

  methods: {
    preventRightClick () {
      return false
    }
  }
}
</script>
